import { InputPassword } from "components";
import React, { useState } from 'react';
import { Box, Stack, Snackbar, Typography, List, ListItem } from '@mui/material';
import { userResetPassword, updatePassword } from 'services';
import { useNavigate, useLocation } from "react-router";
import LoadingButton from '@mui/lab/LoadingButton';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { EurofinsLogo } from 'components/svg/EurofinsLogo';
import { ElvisConnect } from 'components/svg/ElvisConnect';

export const ResetPassword = () => {
    const navigate = useNavigate(); const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState();
    const location: any = useLocation();
    const otp = location?.state?.data;
    const [valid, setValid] = useState(false);
    const [matchError, setMatchError] = useState(false);
    const [formatError, setFormatError] = useState(false);
    const [oldPwdError, setOldPwdError] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [incorrectError, setIncorrectError] = useState(false);
    const [isValidError, setIsValidError] = useState(false);
    const [isValidErrorMessage, setIsValidErrorMessage] = useState('');

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;

    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[#?!@$%^&*-_])[A-Za-z\d#?!@$%^&*-_]{15,}$/g;
    const validateForm = () => {
        if (password && password.match(passwordPattern) == null) {
            setFormatError(true);
            setTimeout(() => { setFormatError(false) }, 6000);
            return 1
        }
        if (password !== confirmPassword) {
            setMatchError(true);
            setTimeout(() => { setMatchError(false) }, 6000);
            return 2
        }
        return 3
    }
    const confirm = (e: any) => {
        e.preventDefault();
        let validate = validateForm();
        if (validate !== 3) {
            return
        }
        setLoading(true);

        if (labUserCheck?.NeedsPasswordReset === 'True') {
            const params = {
                "Password": password
            }
            updatePassword(params).then((res: any) => {
                if (res && res.status && res.status === 200) {
                    setValid(true);
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('refreshToken', res.data.refreshToken);
                    navigate(`/home`);
                } else if (res.status === 400) {
                    setIncorrectError(true);
                } else if (res.status === 422) {
                    setIsValidError(true);
                    setIsValidErrorMessage(res.data);
                }
            }).finally(() => {
                setLoading(false);
            })
        }
        else {
            const params = {
                token: otp,
                password: password
            }
            userResetPassword(params).then((res: any) => {
                if (res?.status === 200) {
                    setValid(true);
                    setTimeout(() => {
                        setValid(false);
                        navigate('/');
                    }, 3000);
                } else if (res?.status === 409) {
                    setOldPwdError(true);
                } else if (res?.status === 400) {
                    setIncorrectError(true);
                } else if (res.status === 422) {
                    setIsValidError(true);
                    setIsValidErrorMessage(res.data);
                } else {
                    setError(true);
                }
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const clearStorage = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        return '';
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    return (
        <div style={{ minHeight: '100vh', width: '100%', background: 'linear-gradient(to right, #003883, #ee7d11)' }}>
            <form onSubmit={confirm} style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                margin: 0,
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: 3,
                    m: 1,
                    width: '480px',
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                }}>
                    <div><EurofinsLogo /></div>
                    <div><ElvisConnect /></div>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            paddingBottom: '25px',
                            m: 1,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                        }}
                    >
                        <Typography variant="h6" data-testid="reset-title" color="secondary.main">Reset Password</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center',
                            p: 1,
                            width: '100%',
                            m: 1,
                            height: 60,
                            borderRadius: 1,
                        }}
                    >
                        <InputPassword
                            inputProps={{
                                "data-testid": 'password-field',
                            }}
                            pattern={passwordPattern}
                            required
                            onChange={(ev: any) => setPassword(ev.target.value)}
                            label="Password"
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                            m: 1,
                            bgcolor: 'background.paper',
                            height: 10,
                            width: '100%',
                            borderRadius: 1,
                        }}
                    >
                        <InputPassword
                            inputProps={{
                                "data-testid": 'confirmPassword-field',
                            }}
                            required onChange={(ev: any) => setConfirmPassword(ev.target.value)}
                            label="Confirm Password"
                        />
                    </Box>
                    <List sx={{ listStyleType: 'disc', fontSize: '12px', marginLeft: '20px', marginTop: '20px' }}>
                        <ListItem sx={{ display: 'list-item' }}>Password must have at least 15 characters</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Password must have at least one lowercase character (a-z)</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Password must have at least one uppercase character (A-Z)</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Password must have at least one digit (0-9)</ListItem>
                        <ListItem sx={{ display: 'list-item' }}>Password must have at least one special character ('#?!@$%^&*-_')</ListItem>
                    </List>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                            m: 1,
                            width: '100%',
                            bgcolor: 'background.paper',
                            height: 40,
                            borderRadius: 1,
                        }}
                    >
                        <LoadingButton role="confirm-button" loading={loading} type="submit" sx={{ m: 1 }} variant="contained" >
                            Confirm
                        </LoadingButton>
                    </Box>
                </Box>
            </form>
            <Stack>
                <Snackbar open={valid} autoHideDuration={6000} onClose={() => setValid(false)}>
                    <Alert severity="success" onClose={() => setValid(false)}>
                        Password has changed successfully
                    </Alert>
                </Snackbar>
                <Snackbar open={matchError} autoHideDuration={6000} onClose={() => setMatchError(false)}>
                    <Alert severity="error" data-testid="mismatch-error" onClose={() => setMatchError(false)}>
                        Passwords do not match!
                    </Alert>
                </Snackbar>
                <Snackbar open={oldPwdError} autoHideDuration={6000} onClose={() => setOldPwdError(false)}>
                    <Alert severity="error" onClose={() => setOldPwdError(false)}>
                        Sorry, your new password cannot be the same as your old password!
                    </Alert>
                </Snackbar>
                <Snackbar open={formatError} autoHideDuration={6000} onClose={() => setFormatError(false)}>
                    <Alert severity="error" onClose={() => setFormatError(false)}>
                        Password strength is low! Please consider including a minimum of one special character, one digit and it should be of 15 characters.
                    </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert severity="warning" onClose={() => setError(false)}>
                        Something went wrong please try again
                    </Alert>
                </Snackbar>
                <Snackbar open={incorrectError} autoHideDuration={6000} onClose={() => setIncorrectError(false)}>
                    <Alert severity="warning" onClose={() => setIncorrectError(false)}>
                        Old Password is incorrect!
                    </Alert>
                </Snackbar>
                <Snackbar open={isValidError} autoHideDuration={6000} onClose={() => setIsValidError(false)}>
                    <Alert severity="warning" onClose={() => setIsValidError(false)}>
                        {isValidErrorMessage}
                    </Alert>
                </Snackbar>
            </Stack>
        </div>
    )
}
